import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "wideGridContainer": "switch-81d9d7e1-wideGridContainer-WXUgJq",
  "xwideOffset10": "switch-81d9d7e1-xwideOffset10-WXUgJq",
  "wide7": "switch-81d9d7e1-wide7-WXUgJq",
  "confinedOffset4": "switch-81d9d7e1-confinedOffset4-WXUgJq",
  "wideOffset6": "switch-81d9d7e1-wideOffset6-WXUgJq",
  "xwide6": "switch-81d9d7e1-xwide6-WXUgJq",
  "tiny3": "switch-81d9d7e1-tiny3-WXUgJq",
  "wide11": "switch-81d9d7e1-wide11-WXUgJq",
  "confinedOffset6": "switch-81d9d7e1-confinedOffset6-WXUgJq",
  "wideOffset7": "switch-81d9d7e1-wideOffset7-WXUgJq",
  "tinyOffset9": "switch-81d9d7e1-tinyOffset9-WXUgJq",
  "xwideOffset7": "switch-81d9d7e1-xwideOffset7-WXUgJq",
  "tinyOffset10": "switch-81d9d7e1-tinyOffset10-WXUgJq",
  "default11": "switch-81d9d7e1-default11-WXUgJq",
  "defaultOffset11": "switch-81d9d7e1-defaultOffset11-WXUgJq",
  "tinyOffset0": "switch-81d9d7e1-tinyOffset0-WXUgJq",
  "confinedOffset10": "switch-81d9d7e1-confinedOffset10-WXUgJq",
  "xwideOffset9": "switch-81d9d7e1-xwideOffset9-WXUgJq",
  "confined3": "switch-81d9d7e1-confined3-WXUgJq",
  "defaultOffset9": "switch-81d9d7e1-defaultOffset9-WXUgJq",
  "xwideOffset11": "switch-81d9d7e1-xwideOffset11-WXUgJq",
  "tiny1": "switch-81d9d7e1-tiny1-WXUgJq",
  "armstrongGridContainer": "switch-81d9d7e1-armstrongGridContainer-WXUgJq",
  "confined12": "switch-81d9d7e1-confined12-WXUgJq",
  "defaultOffset8": "switch-81d9d7e1-defaultOffset8-WXUgJq",
  "tiny11": "switch-81d9d7e1-tiny11-WXUgJq",
  "defaultOffset5": "switch-81d9d7e1-defaultOffset5-WXUgJq",
  "wideOffset8": "switch-81d9d7e1-wideOffset8-WXUgJq",
  "default12": "switch-81d9d7e1-default12-WXUgJq",
  "confinedOffset11": "switch-81d9d7e1-confinedOffset11-WXUgJq",
  "wide10": "switch-81d9d7e1-wide10-WXUgJq",
  "confined5": "switch-81d9d7e1-confined5-WXUgJq",
  "wide12": "switch-81d9d7e1-wide12-WXUgJq",
  "defaultOffset2": "switch-81d9d7e1-defaultOffset2-WXUgJq",
  "wideOffset5": "switch-81d9d7e1-wideOffset5-WXUgJq",
  "tinyOffset2": "switch-81d9d7e1-tinyOffset2-WXUgJq",
  "confined4": "switch-81d9d7e1-confined4-WXUgJq",
  "confinedOffset0": "switch-81d9d7e1-confinedOffset0-WXUgJq",
  "confined6": "switch-81d9d7e1-confined6-WXUgJq",
  "wideOffset3": "switch-81d9d7e1-wideOffset3-WXUgJq",
  "confined11": "switch-81d9d7e1-confined11-WXUgJq",
  "confinedOffset8": "switch-81d9d7e1-confinedOffset8-WXUgJq",
  "tinyOffset5": "switch-81d9d7e1-tinyOffset5-WXUgJq",
  "confined0": "switch-81d9d7e1-confined0-WXUgJq",
  "xwide3": "switch-81d9d7e1-xwide3-WXUgJq",
  "default2": "switch-81d9d7e1-default2-WXUgJq",
  "xwide5": "switch-81d9d7e1-xwide5-WXUgJq",
  "confinedOffset5": "switch-81d9d7e1-confinedOffset5-WXUgJq",
  "confined7": "switch-81d9d7e1-confined7-WXUgJq",
  "wide0": "switch-81d9d7e1-wide0-WXUgJq",
  "xwideOffset8": "switch-81d9d7e1-xwideOffset8-WXUgJq",
  "tinyOffset4": "switch-81d9d7e1-tinyOffset4-WXUgJq",
  "defaultOffset10": "switch-81d9d7e1-defaultOffset10-WXUgJq",
  "wideOffset9": "switch-81d9d7e1-wideOffset9-WXUgJq",
  "xwide0": "switch-81d9d7e1-xwide0-WXUgJq",
  "default1": "switch-81d9d7e1-default1-WXUgJq",
  "tiny4": "switch-81d9d7e1-tiny4-WXUgJq",
  "wide6": "switch-81d9d7e1-wide6-WXUgJq",
  "default9": "switch-81d9d7e1-default9-WXUgJq",
  "confined9": "switch-81d9d7e1-confined9-WXUgJq",
  "tinyOffset6": "switch-81d9d7e1-tinyOffset6-WXUgJq",
  "wide3": "switch-81d9d7e1-wide3-WXUgJq",
  "defaultOffset4": "switch-81d9d7e1-defaultOffset4-WXUgJq",
  "xwide9": "switch-81d9d7e1-xwide9-WXUgJq",
  "wideOffset0": "switch-81d9d7e1-wideOffset0-WXUgJq",
  "xwide7": "switch-81d9d7e1-xwide7-WXUgJq",
  "xwideOffset6": "switch-81d9d7e1-xwideOffset6-WXUgJq",
  "gridContainer": "switch-81d9d7e1-gridContainer-WXUgJq",
  "tinyOffset11": "switch-81d9d7e1-tinyOffset11-WXUgJq",
  "wideOffset11": "switch-81d9d7e1-wideOffset11-WXUgJq",
  "xwide4": "switch-81d9d7e1-xwide4-WXUgJq",
  "xwide10": "switch-81d9d7e1-xwide10-WXUgJq",
  "confined2": "switch-81d9d7e1-confined2-WXUgJq",
  "standardGridContainer": "switch-81d9d7e1-standardGridContainer-WXUgJq",
  "tinyOffset3": "switch-81d9d7e1-tinyOffset3-WXUgJq",
  "tinyOffset7": "switch-81d9d7e1-tinyOffset7-WXUgJq",
  "wide1": "switch-81d9d7e1-wide1-WXUgJq",
  "xwide12": "switch-81d9d7e1-xwide12-WXUgJq",
  "row": "switch-81d9d7e1-row-WXUgJq",
  "tiny10": "switch-81d9d7e1-tiny10-WXUgJq",
  "confinedOffset2": "switch-81d9d7e1-confinedOffset2-WXUgJq",
  "default6": "switch-81d9d7e1-default6-WXUgJq",
  "confined1": "switch-81d9d7e1-confined1-WXUgJq",
  "default3": "switch-81d9d7e1-default3-WXUgJq",
  "tiny7": "switch-81d9d7e1-tiny7-WXUgJq",
  "tiny2": "switch-81d9d7e1-tiny2-WXUgJq",
  "tinyOffset8": "switch-81d9d7e1-tinyOffset8-WXUgJq",
  "default10": "switch-81d9d7e1-default10-WXUgJq",
  "wideOffset1": "switch-81d9d7e1-wideOffset1-WXUgJq",
  "default0": "switch-81d9d7e1-default0-WXUgJq",
  "defaultOffset1": "switch-81d9d7e1-defaultOffset1-WXUgJq",
  "confinedOffset9": "switch-81d9d7e1-confinedOffset9-WXUgJq",
  "xwideOffset4": "switch-81d9d7e1-xwideOffset4-WXUgJq",
  "xwide8": "switch-81d9d7e1-xwide8-WXUgJq",
  "wide2": "switch-81d9d7e1-wide2-WXUgJq",
  "xwideOffset5": "switch-81d9d7e1-xwideOffset5-WXUgJq",
  "tiny8": "switch-81d9d7e1-tiny8-WXUgJq",
  "confinedOffset1": "switch-81d9d7e1-confinedOffset1-WXUgJq",
  "wide4": "switch-81d9d7e1-wide4-WXUgJq",
  "wideOffset2": "switch-81d9d7e1-wideOffset2-WXUgJq",
  "xwideOffset1": "switch-81d9d7e1-xwideOffset1-WXUgJq",
  "confined10": "switch-81d9d7e1-confined10-WXUgJq",
  "wide5": "switch-81d9d7e1-wide5-WXUgJq",
  "wideOffset10": "switch-81d9d7e1-wideOffset10-WXUgJq",
  "defaultOffset7": "switch-81d9d7e1-defaultOffset7-WXUgJq",
  "defaultOffset3": "switch-81d9d7e1-defaultOffset3-WXUgJq",
  "tiny9": "switch-81d9d7e1-tiny9-WXUgJq",
  "xwideOffset3": "switch-81d9d7e1-xwideOffset3-WXUgJq",
  "default8": "switch-81d9d7e1-default8-WXUgJq",
  "xwide2": "switch-81d9d7e1-xwide2-WXUgJq",
  "xwide1": "switch-81d9d7e1-xwide1-WXUgJq",
  "wideOffset4": "switch-81d9d7e1-wideOffset4-WXUgJq",
  "xwideOffset0": "switch-81d9d7e1-xwideOffset0-WXUgJq",
  "default4": "switch-81d9d7e1-default4-WXUgJq",
  "defaultOffset6": "switch-81d9d7e1-defaultOffset6-WXUgJq",
  "wide8": "switch-81d9d7e1-wide8-WXUgJq",
  "default7": "switch-81d9d7e1-default7-WXUgJq",
  "tiny5": "switch-81d9d7e1-tiny5-WXUgJq",
  "tiny12": "switch-81d9d7e1-tiny12-WXUgJq",
  "confinedOffset3": "switch-81d9d7e1-confinedOffset3-WXUgJq",
  "tinyOffset1": "switch-81d9d7e1-tinyOffset1-WXUgJq",
  "grid": "switch-81d9d7e1-grid-WXUgJq",
  "confinedOffset7": "switch-81d9d7e1-confinedOffset7-WXUgJq",
  "tiny0": "switch-81d9d7e1-tiny0-WXUgJq",
  "tiny6": "switch-81d9d7e1-tiny6-WXUgJq",
  "xwideOffset2": "switch-81d9d7e1-xwideOffset2-WXUgJq",
  "confined8": "switch-81d9d7e1-confined8-WXUgJq",
  "xwide11": "switch-81d9d7e1-xwide11-WXUgJq",
  "col": "switch-81d9d7e1-col-WXUgJq",
  "default5": "switch-81d9d7e1-default5-WXUgJq",
  "wide9": "switch-81d9d7e1-wide9-WXUgJq"
};